import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { hostedLegalPageAssetsEnabled } from '../../util/legalPageAssets';

export const ASSET_NAME = 'privacy-policy';

/**
 * Das Console-Asset wird nur geladen, wenn es auch verwendet wird.
 * Sonst holt die Seite eine Fassung, die `resolvePrivacyPolicyPageAssetData`
 * ohnehin verwirft — und schickt sie über den Preloaded State an jeden Browser.
 * Bei einem Rechtstext heisst das: zwei Fassungen unterwegs, eine davon veraltet.
 */
export const loadData = (params, search) => dispatch => {
  if (!hostedLegalPageAssetsEnabled()) {
    return Promise.resolve();
  }
  const pageAsset = { privacyPolicy: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
